<!--  -->
<template>
  <div>
    <!-- 使用transition组件解决路由跳转页面卡顿感 -->

    <transition name="fade-transform" mode="out-in">
      <!-- <keep-alive> -->
      <!-- <div>dsfhdsfhk</div> -->
      <home-page v-if="isHomePageShow"></home-page>
      <router-view v-else></router-view>
      <!-- </keep-alive> -->
    </transition>
  </div>
</template>

<script>
import HomePage from '@/views/home/homePage.vue'
export default {
  props:{
    isHomePageShow:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {};
  },

  components: {
    HomePage
  },

  mounted() {},

  methods: {}
};
</script>
<style scoped>
/* 
enter-active 定义进入过渡的结束状态
leave-active 定义离开过渡的结束状态
 */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.2s;
}

/* 
enter定义进入过渡的开始状态
 */
.fade-transform-enter {
  opacity: 0;
  transform: translateX(30px);
}
/* 
leave-to离场动画结束后的状态
 */
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}
</style>